import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function CreatorSection() {
  return <section className="bg-brand-cream py-10 md:py-14" data-id="element-43">
      <div className="max-w-6xl mx-auto px-4" data-id="element-44">
        <FadeIn data-id="element-45">
          <h2 className="text-3xl md:text-5xl font-bold text-brand-brown text-center mb-16" data-id="element-46">
            Conocé a Stella Pereira
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-47">
          {/* Photo */}
          <FadeIn delay={0.1} direction="left" data-id="element-48">
            <div className="relative" data-id="element-49">
              <img src="https://cdn.magicpatterns.com/uploads/utoo1dDrjnr5ixXWoYvjRX/heylloyd-image-1772481482614.png" alt="Stella Pereira — creadora del Método Milhojas Perfecta" className="rounded-3xl shadow-warm-lg w-full object-cover" data-id="element-50" />
              <div className="absolute -bottom-4 -left-4 bg-brand-gold-dark text-white font-serif italic text-lg px-6 py-3 rounded-2xl shadow-lg" data-id="element-51">
                "Alma y Harina" 🧁
              </div>
            </div>
          </FadeIn>

          {/* Bio */}
          <FadeIn delay={0.2} direction="right" data-id="element-52">
            <div className="space-y-6" data-id="element-53">
              <p className="text-xl md:text-2xl text-brand-brown leading-relaxed" data-id="element-54">
                <span className="font-bold text-brand-gold-dark" data-id="element-55">
                  Stella Pereira
                </span>{' '}
                es pastelera artesanal, creadora del método "Milhojas Perfecta"
                y fundadora de{' '}
                <span className="font-serif italic" data-id="element-56">Alma y Harina</span>.
              </p>
              <p className="text-lg text-brand-brown/80 leading-relaxed" data-id="element-57">
                Con más de 15 años de experiencia en pastelería argentina,
                Stella perfeccionó una técnica que permite a cualquier persona —
                sin importar su nivel de experiencia — lograr una milhojas con
                capas ultra-finas, crocantes y un merengue italiano impecable.
              </p>
              <p className="text-lg text-brand-brown/80 leading-relaxed" data-id="element-58">
                Lo que empezó como una pasión familiar se convirtió en un método
                que ya transformó la cocina de cientos de alumnas en todo el
                país. Muchas de ellas hoy venden sus milhojas y generan ingresos
                desde casa.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}